import { BRAND_LIST, CountryLanguageSwitcher, DistanceUnit } from 'typings'
import * as Typings from '../typings'

const AustriaLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'AT',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Austria',
  SHORT_NAME: 'AT',

  DISPLAY_NAME: 'Austria (English)',
  DISPLAY_COUNTRY: 'Austria (English)',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 47.6699049,
    INITIAL_LONGITUDE: 10.7065316,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Burgenland',
    '2': 'Carinthia',
    '3': 'Lower Austria',
    '4': 'Salzburg',
    '5': 'Styria',
    '6': 'Tyrol',
    '7': 'Upper Austria',
    '8': 'Vienna',
    '9': 'Vorarlberg',
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/eu-at/en/',

  MAP_MOBILE_URL: 'https://map.uniqlo.com/eu-at/en/',

  CONTACT_US_URL: 'https://faq-eu.uniqlo.com/',
  TERMS_OF_USE_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=en&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_3',
  PRIVACY_POLICY_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=dk&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_2',

  POSTCODE_FORMAT: /^[0-9]{4}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  DISTANCE_UNIT: DistanceUnit.KM,

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default AustriaLocale
